import { getAgencyAgentsByAPI, getAgencyProfileByAPI } from '@/api/agency';
import { MutationTypes, getDefaultAgencyProfile } from '@/helpers/agencyProfileHelper';
import { AgencyAgent, AgencyProfile, ApiCallStatus } from '@/types-agency';
import { ActionContext } from 'vuex';

export interface AgencyProfileState {
  agencyProfile?: AgencyProfile;
  agencyAgents?: AgencyAgent[];
  profileApiStatus: ApiCallStatus;
  agentsApiStatus: ApiCallStatus;
}

const getInitialState = (): AgencyProfileState => ({
  agencyProfile: getDefaultAgencyProfile() as AgencyProfile,
  agencyAgents: [],
  profileApiStatus: ApiCallStatus.READY,
  agentsApiStatus: ApiCallStatus.READY,
});

const mutations = {
  setAgencyProfile(state: AgencyProfileState, agencyProfile: AgencyProfile): void {
    state.agencyProfile = agencyProfile;
  },
  setAgencyAgents(state: AgencyProfileState, agencyAgents: AgencyAgent[]): void {
    state.agencyAgents = agencyAgents;
  },
  setProfileApiStatus(state: AgencyProfileState, status: ApiCallStatus): void {
    state.profileApiStatus = status;
  },
  setAgentsApiStatus(state: AgencyProfileState, status: ApiCallStatus): void {
    state.agentsApiStatus = status;
  },
};

const getters = {
  getAgencyProfile: (state: AgencyProfileState): AgencyProfile =>
    state.agencyProfile ?? getDefaultAgencyProfile(),
  getAgencyAgents: (state: AgencyProfileState): AgencyAgent[] => state.agencyAgents || [],
  getProfileApiStatus: (state: AgencyProfileState): ApiCallStatus => state.profileApiStatus,
  getAgentsApiStatus: (state: AgencyProfileState): ApiCallStatus => state.agentsApiStatus,
};

const actions = {
  async fetchAgencyProfile(context: ActionContext<AgencyProfileState, any>): Promise<void> {
    context.commit(MutationTypes.SET_PROFILE_API_STATUS, ApiCallStatus.IN_PROGRESS);
    try {
      const agencyProfile = await getAgencyProfileByAPI();
      context.commit(MutationTypes.SET_AGENCY_PROFILE, agencyProfile);
      context.commit(MutationTypes.SET_PROFILE_API_STATUS, ApiCallStatus.SUCCESS);
    } catch (error) {
      context.commit(MutationTypes.SET_PROFILE_API_STATUS, ApiCallStatus.ERROR);
      throw error;
    }
  },
  async fetchAgencyAgents(context: ActionContext<AgencyProfileState, any>): Promise<void> {
    context.commit(MutationTypes.SET_AGENTS_API_STATUS, ApiCallStatus.IN_PROGRESS);
    try {
      const agencyAgents = await getAgencyAgentsByAPI();
      context.commit(MutationTypes.SET_AGENCY_AGENTS, agencyAgents);
      context.commit(MutationTypes.SET_AGENTS_API_STATUS, ApiCallStatus.SUCCESS);
    } catch (error) {
      context.commit(MutationTypes.SET_AGENTS_API_STATUS, ApiCallStatus.ERROR);
      throw error;
    }
  },
};

const _default = {
  namespaced: true,
  state: getInitialState,
  getters,
  mutations,
  actions,
};
export default _default;
